import React, { useContext, useEffect, FC, useState } from 'react';

import { AppBar, Tab, Tabs } from '@material-ui/core';
import { navigate } from '@reach/router';

import { GlobalContext } from '../../../store';

import { InnerRouter } from '../../../components/AnimatedRouter';
import useGetHoleRange from './Utils/getHoleRange';
import { getRouterDirection } from './Utils/getRouterDirection';
import { IGame } from '../../../store/player/games/store';
import { useShotgunGameMetadata } from '../ClubHome/CurrentEvent/Components/CurrentEventTeeTimeParings/useShotgunGameMetadata';
import { shiftArray } from './Utils/shiftArray';
import useLocation from '../../../contrib/Hooks/useLocation.hook';

const tabClasses = {
  selected: 'selected',
  wrapper: 'tab-wrapper'
};

interface IProps {
  children: any;
  eventId: number;
  roundId: number;
}

const SetScores: FC<IProps> = props => {
  const {
    actions: {
      events: { get: getEvent },
      games: { getAllFutureGames }
    },
    games
  } = useContext(GlobalContext);

  const { location } = useLocation();

  const { children, eventId, roundId } = props;

  const [currentGame, setCurrentGame] = useState<IGame>();
  const [holesRangeArray, setholesRangeArray] = useState<number[]>([]);
  const [selectedTab, setSelectedTab] = useState<number>(0);

  const { isShotgun, startingHole } = useShotgunGameMetadata(currentGame);

  const holesRange = useGetHoleRange(eventId, roundId);

  const PAGES = {
    complete: String(holesRange.length + 1),
    'set-scorer': String(holesRange.start)
  };

  useEffect(() => {
    const routeRegex = new RegExp(`\\/(hole)\\/(\\d+)`, 'mi');

    const matches = location.pathname.match(routeRegex);

    if (!!matches) {
      const hole = Number(matches[2]);

      if (isShotgun) {
        const startingHoleDifference = hole - startingHole;

        setSelectedTab(
          startingHoleDifference >= 0
            ? startingHoleDifference === 0
              ? holesRange.length
              : startingHoleDifference
            : holesRange.length + startingHoleDifference
        );
      } else {
        setSelectedTab(hole);
      }
    }
  }, [location.pathname, isShotgun, startingHole]);

  useEffect(() => {
    const matches = location.pathname.includes('complete');

    if (matches) {
      setSelectedTab(holesRangeArray.length + 1);
    }
  }, [location, holesRangeArray]);

  useEffect(() => {
    const matches = location.pathname.includes('set-scorer');

    if (matches) {
      setSelectedTab(0);
    }
  }, [location]);

  const setTab = (_: any, activeTab: number) => {
    const baseURl = `/event-scores/${eventId}/round/${roundId}`;

    switch (activeTab) {
      case 0:
        navigate(`${baseURl}/set-scorer`);
        break;
      case Number(PAGES.complete):
        if (isShotgun) {
          navigate(`${baseURl}/hole/1/`);
        } else {
          navigate(`${baseURl}/complete`);
        }
        break;
      default:
        if (isShotgun) {
          const hole =
            activeTab + startingHole >= Number(PAGES.complete)
              ? (activeTab + startingHole) % holesRange.length
              : Number(activeTab) + Number(holesRange.start) + Number(startingHole);

          navigate(`${baseURl}/hole/${hole}/`);
        } else {
          navigate(`${baseURl}/hole/${Number(activeTab) + Number(holesRange.start)}/`);
        }
        break;
    }
  };

  useEffect(() => {
    getEvent(String(eventId)).catch();
  }, [eventId]);

  useEffect(() => {
    getAllFutureGames().catch();
  }, [eventId]);

  useEffect(() => {
    if (Object.values(games).length > 0 && roundId) {
      const newCurrentGame: IGame = Object.values(games).find(
        game => game.round.id === Number(roundId)
      );

      setCurrentGame(newCurrentGame);
    }
  }, [games]);

  useEffect(() => {
    const rangeArray = Array.from(Array(holesRange.length).keys());

    setholesRangeArray(isShotgun ? shiftArray(rangeArray, -1, startingHole) : rangeArray);
  }, [holesRange, isShotgun, startingHole]);

  return (
    <div className="home set-scores wrapper">
      <div>
        <AppBar position="static" color="default" className="bar">
          <Tabs
            value={selectedTab}
            onChange={setTab}
            indicatorColor="primary"
            textColor="primary"
            variant="scrollable"
            scrollButtons="on"
            classes={{
              indicator: 'bar-indicator',
              scrollButtons: 'bar-arrow',
              scrollable: 'bar-scrollable'
            }}
          >
            <Tab label="SETUP" className="setup" classes={tabClasses} />

            {holesRangeArray.map((hole: number) => (
              <Tab
                label={hole + 1 + holesRange.start}
                key={`tab-hole-${hole + holesRange.start}`}
                className="hole"
                classes={tabClasses}
              />
            ))}

            <Tab label="COMPLETE" className="setup" classes={tabClasses} />
          </Tabs>
        </AppBar>

        {children && (
          <InnerRouter
            className="slow"
            location={location}
            transitionKey={`tab-${selectedTab}`}
            direction={getRouterDirection}
          >
            {children}
          </InnerRouter>
        )}
      </div>
    </div>
  );
};

export default SetScores;
